import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const Sms = () => {
  const [smsUserData, setSmsUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [clients, setClients] = useState([]);

  const [selectedClientType, setSelectedClientType] = useState(null);

  // const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");

  // const isMatch = password === confirmPassword;

 
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [smsForm, setSmsForm] = useState({
    SuperId: "",
    DefaultSMSMsg: "",
    APIURL: "",
    URL: "",
    Username: "",
    Password: "",
    ConfirmPassword: "",
    BulkTotalSMS: "",
    FromKey: "",
    CreatedBy: "1",
    UpdatedBy: "1",
  });

  const resetSMSForm = () => {
    setSmsForm({
      SuperId: "",
      DefaultSMSMsg: "",
      APIURL: "",
      URL: "",
      Username: "",
      Password: "",
      ConfirmPassword: "",
      BulkTotalSMS: "",
      FromKey: "",
      CreatedBy: "1",
      UpdatedBy: "1",
    });

    setSelectedClientType(null);
  };

  const [editSMSForm, setEditSMSForm] = useState({
    SuperId: "",
    APIURL: "",
    URL: "",
    BulkTotalSMS: "",
    Username: "",
    Password: "",
    ConfirmPassword: "",
    FromKey: "",
    DefaultSMSMsg: "",
  });

  const columns = [
    {
      title: "Super Id",
      dataIndex: "SuperId",
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },
 
    {
      title: "APIUrl",
      dataIndex: "APIURL",
      render: (text) => (
        <span title={text}>
          {text?.length > 30 ? text.substring(0, 30) + "..." : text}
        </span>
      ),
    },
    {
      title: "DefaultSMSMsg",
      dataIndex: "DefaultSMSMsg",
      render: (text) => (
        <span title={text}>
          {text?.length > 30 ? text.substring(0, 30) + "..." : text}
        </span>
      ),
    },

    {
      title: "Actions",
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_sms_user"
            onClick={() => handleEdit(record)}
          >
            <i className="ti ti-edit" />
          </Link>

          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
            onClick={() => deleteSMSUser(String(record.SuperId))}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const getSmsUsersData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getsmsinfo`);
      const data = response.data?.ResultData || [];
      setSmsUserData(data);
    } catch (error) {
      console.error("Error fetching inactive organizations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSmsUsersData();
  }, []);

  const fetchClintes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}/api/getorganizationtype`);

      if (!res.ok) throw new Error("Failed to fetch ClientTypes");
      const data = await res.json();
      console.log(data.Status, "cbsjkahchjksad");

      if (data.Status === true) {
        setClients(
          data.ResultData.map((item) => ({
            label: item.OrgName, // FIXED
            value: String(item.SuperId),
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  const addSMSUser = async () => {
    setAddLoading(true);

    const payload = {
      SuperId: smsForm.SuperId,
      DefaultSMSMsg: smsForm.DefaultSMSMsg,
      APIURL: smsForm.APIURL,
      URL: smsForm.URL,
      Username: smsForm.Username,
      Password: smsForm.Password, // ✔ only real password
      BulkTotalSMS: smsForm.BulkTotalSMS,
      FromKey: smsForm.FromKey,
      CreatedBy: smsForm.CreatedBy,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/addsms`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.ResultData[0].Status === "1") {
        Swal.fire("Success", "SMS User Added Successfully", "success");
        document.getElementById("close_add_plans").click();
        resetSMSForm();
        getSmsUsersData();
      } else {
        Swal.fire("Error", data.ResultMessage || "Failed to Add", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
      console.error(error);
    } finally {
      setAddLoading(false);
    }
  };

  const handleClientSelect = (option) => {
    setSelectedClientType(option);
    setSmsForm({ ...smsForm, SuperId: option.value });
  };

  const handleSMSChange = (e) => {
    const { name, value } = e.target;

    setSmsForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle Edit Click - Populate Modal (optional enhancement)
  const [selectedClient, setSelectedClient] = useState("");
  const handleEdit = (record) => {
    console.log("Editing SMS User:", record);

    setEditSMSForm({
      SuperId: String(record.SuperId || ""),
      APIURL: record.APIURL || "",
      URL: record.URL || "",
      BulkTotalSMS: String(record.BulkTotalSMS || ""),
      Username: record.Username || "",
      Password: record.Password || "",
      ConfirmPassword: record.Password || "", // prefill same for match
      FromKey: record.FromKey || "",
      DefaultSMSMsg: record.DefaultSMSMsg || "",
      UpdatedBy: "1",
    });
    setSelectedClient(record.OrgName);
  };

  useEffect(() => {
    fetchClintes();
  }, []);

  const handleEditSMSChange = (e) => {
    setEditSMSForm({
      ...editSMSForm,
      [e.target.name]: e.target.value,
    });
  };

  const updateSMSUser = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/smsedit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editSMSForm),
      });

      const data = await response.json();

      if (data.ResultData[0].Status === "1") {
        Swal.fire("Updated!", "SMS User Updated", "success");
        document.getElementById("closeModel").click();
        getSmsUsersData();
      } else {
        Swal.fire("Error", data.ResultMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const deleteSMSUser = async (superId) => {
    try {
      const confirm = await Swal.fire({
        title: "Are you sure?",
        text: "This SMS User will be deleted permanently!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
      });

      if (!confirm.isConfirmed) return;

      const response = await fetch(`${API_BASE_URL}/api/smsdelete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ SuperId: superId }),
      });

      const data = await response.json();

      if (data.ResultData[0].Status === "1") {
        Swal.fire("Deleted!", "SMS User deleted successfully.", "success");
        getSmsUsersData(); // refresh table
      } else {
        Swal.fire("Error", data.ResultMessage, "error");
      }
    } catch (err) {
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  console.log(editSMSForm, "editSMSForm");

  useEffect(() => {
    const modal = document.getElementById("add_plans");

    const handleClose = () => {
      resetSMSForm();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <style>
        {`
.custom-switch.ant-switch-checked {
  background-color:  #dc2626!important; 
}
.custom-switch.ant-switch {
  background-color:#16a34a  !important; 
}
           `}
      </style>

      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>SMS Information Details</h4>
                {/* <h6>Manage your Users</h6> */}
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Refresh"
                >
                  <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                </Link>
              </li> */}
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_plans"
                className="btn btn-primary"
              >
                <i className="ti ti-circle-plus me-1"></i>
                Add
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Sms Users List</h5>

              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={smsUserData}
                     
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* /Add model */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add SMS User</h4>
              <button
                id="close_add_plans"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetSMSForm()}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-3">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">
                      Super Id <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="w-100"
                      options={clients}
                      placeholder="Choose"
                      value={selectedClientType}
                      onChange={handleClientSelect}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      APIUrl <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="APIURL"
                      value={smsForm.APIURL}
                      onChange={handleSMSChange}
                      placeholder="Enter APIUrl"
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      Url <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="URL"
                      value={smsForm.URL}
                      onChange={handleSMSChange}
                      placeholder="Enter Url"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      Bulk Total SMS <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="BulkTotalSMS"
                      value={smsForm.BulkTotalSMS}
                      onChange={handleSMSChange}
                      placeholder="Enter Bulk Total SMS"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      User Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Username"
                      value={smsForm.Username}
                      onChange={handleSMSChange}
                      placeholder="Enter User Name"
                      autoComplete="new-password"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      Password <span className="text-danger">*</span>
                    </label>

                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        name="Password"
                        value={smsForm.Password}
                        onChange={handleSMSChange}
                        placeholder="Enter Password"
                        autoComplete="new-password"
                      />

                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i className="ti ti-eye"></i>
                        ) : (
                          <i className="ti ti-eye-off"></i>
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      Confirm Password <span className="text-danger">*</span>
                    </label>

                    <div className="input-group">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        name="ConfirmPassword"
                        value={smsForm.ConfirmPassword}
                        onChange={handleSMSChange}
                        placeholder="Enter Confirm Password"
                      />

                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <i className="ti ti-eye"></i>
                        ) : (
                          <i className="ti ti-eye-off"></i>
                        )}
                      </span>
                    </div>

                    {/* Validation messages */}
                    {smsForm.ConfirmPassword.length > 0 &&
                      smsForm.Password !== smsForm.ConfirmPassword && (
                        <small className="text-danger fw-bold">
                          ❌ Passwords do not match
                        </small>
                      )}

                    {smsForm.ConfirmPassword.length > 0 &&
                      smsForm.Password === smsForm.ConfirmPassword && (
                        <small className="text-success fw-bold">
                          ✅ Passwords matched
                        </small>
                      )}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      From Key <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="FromKey"
                      value={smsForm.FromKey}
                      onChange={handleSMSChange}
                      placeholder="Enter From Key"
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Default SMS Message <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      name="DefaultSMSMsg"
                      value={smsForm.DefaultSMSMsg}
                      onChange={handleSMSChange}
                      rows="3"
                      placeholder="Enter Default SMS Message"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => resetSMSForm()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addSMSUser}
                  // data-bs-dismiss="modal"
                  disabled={smsForm.Password !== smsForm.ConfirmPassword}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Edit Plan */}

      <div className="modal fade" id="edit_sms_user">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit SMS User</h4>
              <button
                id="closeModel"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="modal-body pb-3">
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Client</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Client"
                      value={selectedClient}
                      disabled
                    />
                  </div>

                  {/* Super Id */}
                  <div className="col-md-4">
                    <label className="form-label">Super Id</label>
                    <input
                      type="text"
                      className="form-control"
                      name="SuperId"
                      value={editSMSForm.SuperId}
                      disabled
                    />
                  </div>

                  {/* API URL */}
                  <div className="col-md-4">
                    <label className="form-label">APIUrl</label>
                    <input
                      type="text"
                      className="form-control"
                      name="APIURL"
                      value={editSMSForm.APIURL}
                      onChange={handleEditSMSChange}
                    />
                  </div>

                  {/* URL */}
                  <div className="col-md-4">
                    <label className="form-label">Url</label>
                    <input
                      type="text"
                      className="form-control"
                      name="URL"
                      value={editSMSForm.URL}
                      onChange={handleEditSMSChange}
                    />
                  </div>

                  {/* Bulk SMS */}
                  <div className="col-md-4">
                    <label className="form-label">Bulk Total SMS</label>
                    <input
                      type="number"
                      className="form-control"
                      name="BulkTotalSMS"
                      value={editSMSForm.BulkTotalSMS}
                      onChange={handleEditSMSChange}
                    />
                  </div>

                  {/* Username */}
                  <div className="col-md-4">
                    <label className="form-label">User Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Username"
                      value={editSMSForm.Username}
                      onChange={handleEditSMSChange}
                    />
                  </div>

                  {/* Password */}
                  <div className="col-md-4">
                    <label className="form-label">Password</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        name="Password"
                        value={editSMSForm.Password}
                        onChange={handleEditSMSChange}
                      />

                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i className="ti ti-eye"></i>
                        ) : (
                          <i className="ti ti-eye-off"></i>
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="col-md-4">
                    <label className="form-label">Confirm Password</label>

                    <div className="input-group">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        name="ConfirmPassword"
                        value={editSMSForm.ConfirmPassword}
                        onChange={handleEditSMSChange}
                      />

                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <i className="ti ti-eye"></i>
                        ) : (
                          <i className="ti ti-eye-off"></i>
                        )}
                      </span>
                    </div>

                    {editSMSForm.ConfirmPassword.length > 0 &&
                      editSMSForm.Password !== editSMSForm.ConfirmPassword && (
                        <small className="text-danger fw-bold">
                          ❌ Passwords do not match
                        </small>
                      )}

                    {editSMSForm.ConfirmPassword.length > 0 &&
                      editSMSForm.Password === editSMSForm.ConfirmPassword && (
                        <small className="text-success fw-bold">
                          ✅ Passwords matched
                        </small>
                      )}
                  </div>

                  {/* From Key */}
                  <div className="col-md-4">
                    <label className="form-label">From Key</label>
                    <input
                      type="text"
                      className="form-control"
                      name="FromKey"
                      value={editSMSForm.FromKey}
                      onChange={handleEditSMSChange}
                    />
                  </div>

                  {/* Default Message */}
                  <div className="col-md-12">
                    <label className="form-label">Default SMS Message</label>
                    <textarea
                      className="form-control"
                      name="DefaultSMSMsg"
                      rows="3"
                      value={editSMSForm.DefaultSMSMsg}
                      onChange={handleEditSMSChange}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={
                    editSMSForm.Password !== editSMSForm.ConfirmPassword
                  }
                  onClick={updateSMSUser}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* /Edit Plan */}
    </>
  );
};

export default Sms;
